module.exports = __webpack_public_path__ + "static/media/xls-file.9f384e71.svg";